import {Presenter} from '../../../../../Support/with_presenter';

export class CrewWorkoutsPresenter implements Presenter {
    public async mount(): Promise<void> {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }
}
